const STATUSES_ES = {
  added: "Añadido",
  archived: "Archivado",
  canceled: "Cancelado",
  complete: "Completo",
  confirmed: "Por venir",
  ended: "Finalizado",
  expired: "Expirado",
  expires_soon: "Expira pronto",
  incomplete: "Incompleto",
  paid: "Pagado",
  paymentToCome: "Pago pendiente",
  pending: "Pendiente",
  proposed: "Propuesto",
  refused: "Rechazado",
  scheduled: "A tratar",
  sent: "A tratar",
  started: "Iniciado",
  to_add: "Por añadir",
  to_renew: "A renovar",
  toAdd: "Por añadir",
  toCome: "Por venir",
  toCorrect: "Por corregir",
  toJustify: "Por justificar",
  toPay: "Por pagar",
  up_to_date: "Al día",
  validated: "Validado",
  validationInProgress: "Validación en curso",
  waiting_for_confirmation: "Por venir",
  waiting_for_validation: "En curso",
} as const;

export default STATUSES_ES;
